/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Orgmanagerv1Timeframe } from '../models/Orgmanagerv1Timeframe';
import { V1ExportConfig } from '../models/V1ExportConfig';
import { V1ExportType } from '../models/V1ExportType';
import { V1Schedule } from '../models/V1Schedule';
import { HttpFile } from '../http/http';

export class TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask {
    /**
    * Owning organization.
    */
    'orgId'?: string;
    /**
    * Human-readable report name. Whitespace-only values are rejected.
    */
    'name': string;
    'timeframe'?: Orgmanagerv1Timeframe;
    'exportType'?: V1ExportType;
    'exportConfig'?: V1ExportConfig;
    /**
    * Campaign IDs included in the report. Required (non-empty) if order_line_ids is empty.
    */
    'campaignIds'?: Array<string>;
    /**
    * Order line IDs included in the report. Required (non-empty) if campaign_ids is empty.
    */
    'orderLineIds'?: Array<string>;
    /**
    * Schedules attached to this report. Returned on Get and List. May be provided on Create — schedules are created together with the report in a single request. Not modifiable via UpdateReport; use the Schedule endpoints to mutate.
    */
    'schedules'?: Array<V1Schedule>;
    /**
    * Server-assigned creation time.
    */
    'createTime'?: Date;
    /**
    * Server-assigned last-update time.
    */
    'updateTime'?: Date;
    /**
    * Set when the resource has been deleted; null otherwise.
    */
    'deleteTime'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "timeframe",
            "baseName": "timeframe",
            "type": "Orgmanagerv1Timeframe",
            "format": ""
        },
        {
            "name": "exportType",
            "baseName": "export_type",
            "type": "V1ExportType",
            "format": ""
        },
        {
            "name": "exportConfig",
            "baseName": "export_config",
            "type": "V1ExportConfig",
            "format": ""
        },
        {
            "name": "campaignIds",
            "baseName": "campaign_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "orderLineIds",
            "baseName": "order_line_ids",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "schedules",
            "baseName": "schedules",
            "type": "Array<V1Schedule>",
            "format": ""
        },
        {
            "name": "createTime",
            "baseName": "create_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updateTime",
            "baseName": "update_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deleteTime",
            "baseName": "delete_time",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask.attributeTypeMap;
    }

    public constructor() {
    }
}

